import { i18nDispatcherRkDashboard } from 'models/i18n';
import { MetricValueType } from 'utils/constants';
import { PanelRkColumn } from 'views/modules/Dispatcher/RkDashboard/PanelRk/panelRkModels';
import { ReservedCapacityGuardMode } from 'utils/characteristic';

// ==============================|| I18N EN ||============================== //

const enRkDashboard: i18nDispatcherRkDashboard = {
  mdsPanel: {
    title: 'MDS: ',
    reservedCapacityGuardMode: {
      [ReservedCapacityGuardMode.AUTO]: 'Auto',
      [ReservedCapacityGuardMode.MANUAL]: 'Manual'
    },
    energyOfftakeChart: {
      label: {
        x: 'Time [min]',
        y: 'Consumption [MWh]'
      },
      series: {
        [MetricValueType.activeEnergyOfftake]: 'Energy consumption',
        [MetricValueType.energyPlannedProduction]: 'Consumption prediction',
        reservedCapacityMaintainLevel: 'Maintain level',
        reservedCapacityFulfillment: 'Fulfillment energy',
        reservedCapacityFulfillmentWithReserve:
          'Fulfillment energy with Reserve'
      }
    },
    activeEnergyChart: {
      title: 'Power in the current 15 minutes',
      label: {
        x: 'Time [min]',
        y: 'Power [MW]'
      },
      restrictionPrevention: 'Restriction phase',
      series: {
        [MetricValueType.activeEnergyOfftake]: 'Power progress',
        [MetricValueType.energyMaxPower]:
          'Max. value of constant power to maintain RK',
        maxPowerOfftakeInPreventivePeriodPhase:
          'Curve of max. power consumption in the preventive phase of the period',
        reservedCapacity: 'RK',
        reservedCapacityReserve: 'RK reserve'
      }
    },
    alarms: {
      title: 'Alarms',
      removeAll: 'Remove all',
      openAlarms: 'Show overview'
    }
  },
  rkPanel: {
    header: {
      currentConsumptionRk: 'Current consumption RK: {{value}}%',
      elapsedTime: '% of time: {{value}}%',
      reservedCapacity: 'RK: {{value}} MWh',
      newSuggestions: 'New check in {{time}}s',
      checkingInProgress: 'Checking in progress'
    },
    columns: {
      [PanelRkColumn.OOM]: 'OOM',
      [PanelRkColumn.DEVICE]: 'Device',
      [PanelRkColumn.PRIORITY]: 'Priority',
      [PanelRkColumn.CURRENT_POWER]: 'Current power',
      [PanelRkColumn.CONSUMED_POWER]: 'Current energy',
      [PanelRkColumn.ESTIMATED_CONSUMPTION]: 'Est. energy',
      [PanelRkColumn.SUGGESTED_CONSUMPTION]: 'Suggested energy',
      [PanelRkColumn.REQUIRED_CONSUMPTION]: 'Required energy',
      [PanelRkColumn.START_OF_MEASUREMENT]: 'Start of measure',
      [PanelRkColumn.ISSUANCE_OF_MEASUREMENT]: 'Iss. of measure',
      [PanelRkColumn.LEAVE_FOR_LATER]: 'Leave for later',
      [PanelRkColumn.UNIT_PRICE_OF_ENERGY]: 'Unit energy price',
      [PanelRkColumn.DEVIATION_ESTIMATE]: 'Deviation est.',
      [PanelRkColumn.NOMINATION]: 'Nomination'
    },
    message: {
      priorityValidationError: 'Priority must be positive integer or 0'
    },
    changeGuardingActionDialog: {
      title: 'Edit guarding action',
      startOfMeasurement: 'Start of measure',
      plusInterval: '+{{timeInSeconds}}s',
      minusInterval: '-{{timeInSeconds}}s',
      now: 'Now',
      estimatedConsumptionTotal: 'Estimated total consumption',
      estimatedConsumptionTotalValue: '{{value}} MWh',
      reservedCapacity: 'Reserved capacity',
      reservedCapacityValue: '{{value}} MWh',
      estimatedConsumptionDevice: 'Estimated device consumption',
      estimatedConsumptionDeviceValue: '{{value}} MWh',
      leaveForLater: 'Leave guarding action for next period',
      cancelAction: 'Cancel action',
      acceptActionWithChange: 'Accept with change'
    }
  },
  guardingActions: {
    proposedGuardingActions: {
      title: 'Proposed guarding actions',
      onlyCurrent: 'Only current',
      onlyIssued: 'Only issued',
      deliveryPointsSelect: 'DP',
      dialog: {
        accept: {
          title: 'Accept action',
          description: 'Do you want to accept the action?'
        },
        acceptBatch: {
          title: 'Accept guarding actions',
          description: 'Do you want to accept all guarding actions?'
        },
        reject: {
          title: 'Reject action',
          description: 'Do you want to reject the action?'
        }
      }
    },
    proposedGuardingActionsTable: {
      proposalTime: 'Proposal time',
      deviceName: 'Device',
      guardingAction: 'Guarding action',
      acceptTime: 'Time accepted',
      action: 'Action'
    },
    acceptedGuardingActions: {
      title: 'Accepted guarding actions',
      planned: 'Planned',
      applied: 'Applied',
      deliveryPointsSelect: 'DP'
    },
    acceptedGuardingActionsTable: {
      proposalTime: 'Proposal time',
      deviceName: 'Device',
      guardingAction: 'Guarding action',
      acceptTime: 'Time accepted',
      type: 'Type'
    },
    actionReduction: 'Energy reduction from {{fromEnergy}} to {{toEnergy}}',
    actionIncrease: 'Energy increase from {{fromEnergy}} to {{toEnergy}}'
  },
  activityLog: {
    title: 'Activity log'
  }
};

export default enRkDashboard;
